
  import * as noneRuntime$Rj4cu2ffF2gEiWoh0A_45zMVxVq3kG67x_45ji98ulyIFns from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_srvx@0.11.15/node_modules/@nuxt/image/dist/runtime/providers/none'
import * as vercelRuntime$_4MzFdeU7uiGkEV8BqrKfHl6dFZdrOqKaTrtlLILQQ9Q from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_srvx@0.11.15/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "sanity.io",
    "ndhosting.nl",
    "cdninstagram.com",
    "b-cdn.net"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['none']: { provider: noneRuntime$Rj4cu2ffF2gEiWoh0A_45zMVxVq3kG67x_45ji98ulyIFns, defaults: {} },
  ['vercel']: { provider: vercelRuntime$_4MzFdeU7uiGkEV8BqrKfHl6dFZdrOqKaTrtlLILQQ9Q, defaults: {} }
    }
  }
